
var scrollStop = function (element, callback) {

    // Make sure a valid callback was provided
    if (!callback || typeof callback !== 'function') return;

    // Listen for scroll events
    element.addEventListener('scroll', function (event) {

        callback();

    }, false);

};

export default scrollStop;